export default {"src":"/_next/static/media/walletSelected.94e15d9a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};